import { NewTags } from '../types';
import { LambdaTags } from './PatchMassEditLambda';

export function getTagsDiff(
  tags: NewTags,
  defaultTags: NewTags,
  equipmentCount: number,
): LambdaTags {
  const validTags = Object.entries(tags).filter(entry => {
    return entry[1].count === equipmentCount;
  });
  const validDefaultTags = Object.entries(defaultTags).filter(entry => {
    return entry[1].count === equipmentCount;
  });

  const currentList = validTags.map(t => t[0]);
  const startingList = validDefaultTags.map(t => t[0]);

  const removed = startingList.filter(tagId => !currentList.includes(tagId));
  const added = currentList.filter(tagId => !startingList.includes(tagId));

  const removedAsTag = removed.map<LambdaTags[number]>(tagId => {
    return { tagId, action: 'REMOVE' };
  });
  const addedAsTag = added.map<LambdaTags[number]>(tagId => {
    return { tagId, action: 'ADD' };
  });
  return removedAsTag.concat(...addedAsTag);
}
